"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.updateGenAiSalesData = exports.getGenAiSalesData = exports.getPartnerList = exports.getBusinessManagerVersion = exports.updateBotBreakTemplates = exports.updateFeedbackMessages = exports.getFeedbackMessages = exports.getBotBreakTemplates = exports.updateTasks = exports.getTasks = exports.updateBusinessData = exports.getBusinessData = exports.saveSDKConfig = exports.getSDKConfig = void 0;
var constants_1 = __importDefault(require("@src/constants"));
var utils_1 = require("./utils");
/**
 * Fetches SDK configurations
 * @param businessId Id of the business
 */
exports.getSDKConfig = function (businessId) {
    var URL = constants_1["default"].ENDPOINTS.BUSINESS_V2.GET.SDK_CONFIG.replace(':businessId', "" + businessId);
    return utils_1.mogamboRequestV3(URL, 'GET');
};
/**
 * Saves SDK configuration
 * @param businessId ID of the business
 * @param data data to save
 */
exports.saveSDKConfig = function (businessId, data) {
    var URL = constants_1["default"].ENDPOINTS.BUSINESS_V2.PUT.SDK_CONFIG.replace(':businessId', "" + businessId);
    return utils_1.mogamboRequestV3(URL, 'PUT', data);
};
// #region General Settings
/**
 * Fetches General Settings' Business Data
 * @param businessId id of the business whose data is to be fetched
 */
exports.getBusinessData = function (businessId) {
    var url = constants_1["default"].ENDPOINTS.BUSINESS_V2.GET.BUSINESS_DATA.replace(':businessId', "" + businessId);
    return utils_1.mogamboRequestV3(url, 'GET');
};
/**
 * Updates General Settings' Business Data
 * @param partnerId id of the partner for which experts to fetch
 */
exports.updateBusinessData = function (businessId, data) {
    var url = constants_1["default"].ENDPOINTS.BUSINESS_V2.PUT.BUSINESS_DATA.replace(':businessId', "" + businessId);
    return utils_1.mogamboRequestV3(url, 'PUT', data);
};
// #endregion
// #region Content Management
/**
 * Fetches Tasks Data
 * @param businessId id of the business whose data is to be fetched
 */
exports.getTasks = function (businessId) {
    var url = constants_1["default"].ENDPOINTS.BUSINESS_V2.GET.TASKS.replace(':businessId', "" + businessId);
    return utils_1.mogamboRequestV3(url, 'GET');
};
/**
 * Updates Tasks Data
 * @param businessId id of the business whose data is to be fetched
 */
exports.updateTasks = function (businessId, taskData) {
    var url = constants_1["default"].ENDPOINTS.BUSINESS_V2.PUT.TASKS.replace(':businessId', "" + businessId);
    return utils_1.mogamboRequestV3(url, 'PUT', taskData);
};
/**
 * Fetches Bot Break Templates
 * @param businessId id of the business whose data is to be fetched
 */
exports.getBotBreakTemplates = function (businessId) {
    var url = constants_1["default"].ENDPOINTS.BUSINESS_V2.GET.BOT_BREAK_TEMPLATES.replace(':businessId', "" + businessId);
    return utils_1.mogamboRequestV3(url + "?version=3", 'GET');
};
exports.getFeedbackMessages = function (businessId) {
    var url = constants_1["default"].ENDPOINTS.BUSINESS_V2.GET.FEEDBACK_MESSAGES.replace(':businessId', "" + businessId);
    return utils_1.mogamboRequestV3(url, 'GET');
};
exports.updateFeedbackMessages = function (businessId, feedbackMessagesData) {
    var url = constants_1["default"].ENDPOINTS.BUSINESS_V2.GET.FEEDBACK_MESSAGES.replace(':businessId', "" + businessId);
    return utils_1.mogamboRequestV3(url, 'PUT', feedbackMessagesData);
};
/**
 * Updates Bot Break Templates
 * @param businessId id of the business whose data is to be fetched
 */
exports.updateBotBreakTemplates = function (businessId, botBreakTemplateData) {
    var url = constants_1["default"].ENDPOINTS.BUSINESS_V2.PUT.BOT_BREAK_TEMPLATES.replace(':businessId', "" + businessId);
    return utils_1.mogamboRequestV3(url, 'PUT', botBreakTemplateData);
};
// #endregion
// gets business manager version number
exports.getBusinessManagerVersion = function (businessIdentifier) {
    var url = constants_1["default"].ENDPOINTS.BUSINESS_V2.GET.BUSINESS_MANAGER_VERSION.replace(':businessIdentifier', "" + businessIdentifier);
    return utils_1.mogamboRequestV3(url, 'GET');
};
/**
 * Fetches List of partners for user
 * @param userId Id of the User
 */
exports.getPartnerList = function () {
    var URL = constants_1["default"].ENDPOINTS.BUSINESS_V2.GET.PARTNER_LIST;
    return utils_1.mogamboRequestV3(URL, 'GET');
};
exports.getGenAiSalesData = function (businessId) {
    var url = "" + constants_1["default"].ENDPOINTS.BUSINESS_V2.GET.GEN_AI_SALES_DATA + businessId + "/gpt_manager";
    return utils_1.mogamboRequestV3(url, 'GET');
};
exports.updateGenAiSalesData = function (payload, businessId) {
    var url = "" + constants_1["default"].ENDPOINTS.BUSINESS_V2.GET.GEN_AI_SALES_DATA + businessId + "/gpt_manager";
    return utils_1.mogamboRequestV3(url, 'POST', payload);
};
var api_1 = require("@src/containers/BusinessManager/store/api");
__createBinding(exports, api_1, "getPlatformDeployments", "getDeployments");
__createBinding(exports, api_1, "savePlatformDeployments", "saveDeployments");
